import { render } from "./CityCustomSectionsEditor.vue?vue&type=template&id=2324b1b4&scoped=true"
import script from "./CityCustomSectionsEditor.vue?vue&type=script&lang=js"
export * from "./CityCustomSectionsEditor.vue?vue&type=script&lang=js"

import "./CityCustomSectionsEditor.vue?vue&type=style&index=0&id=2324b1b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2324b1b4"]])

export default __exports__